import { render } from "./MainLab.vue?vue&type=template&id=49ca3dad"
import script from "./MainLab.vue?vue&type=script&lang=js"
export * from "./MainLab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__